import { useSelector } from "@/core/redux/store";
import { useMediaQuery } from "usehooks-ts";
import { headerConfig } from "../table-header/header-config";
import { useTemplates } from "./useTemplate";

export default function useGridTemplate() {
  const { hiddenColumnFields } = useSelector(
    (state) => state.supplierResponsesAll
  );
  const getHiddenColumnFieldIndexes = () => {
    const indexes: number[] = [];
    headerConfig.forEach((config, index) => {
      if (hiddenColumnFields.includes(config.field)) {
        indexes.push(index);
      }
    });
    return indexes;
  };

  const template = useTemplates();

  const hiddenColumnFieldIndexes = getHiddenColumnFieldIndexes();

  const extraWidths = hiddenColumnFieldIndexes.map((index) => template[index]);
  const totalExtraWidth = sumPxValues(extraWidths);

  const contemplatedTemplate = template.filter(
    (_, index) => !hiddenColumnFieldIndexes.includes(index)
  );

  const columnsToGiveExtraWidth = contemplatedTemplate.length - 1; // -1 because actions wont change
  const extraWidthPerColumn = totalExtraWidth / columnsToGiveExtraWidth;
  const newTemplate = extraWidthPerColumn
    ? contemplatedTemplate.map((value, index) => {
        if (index === 0) return addToMinmax(value, extraWidthPerColumn);
        if (index === contemplatedTemplate.length - 1) return value;
        return `${parseFloat(removePxValue(value)) + extraWidthPerColumn}px`;
      })
    : contemplatedTemplate;

  return newTemplate.join(" ");
}

function removePxValue(value: string) {
  return value.replace("px", "");
}

function sumPxValues(arr: string[]) {
  return arr
    .map((v) => parseFloat(removePxValue(v)))
    .reduce((a, b) => a + b, 0);
}

function addToMinmax(value: string, extra: number) {
  const match = value.match(/minmax\((\d+)px,(.+)\)/);
  if (!match) return value; // minmax değilse dokunma

  const min = Number(match[1]);
  const max = match[2].trim();

  const newMin = min + extra;

  return `minmax(${newMin}px,${max})`;
}
